// extracted by mini-css-extract-plugin
module.exports = {"cartPage":"styles_cartPage__rmZZh","cartPageContainer":"styles_cartPageContainer__ayX_3","cartPageAsideWrapper":"styles_cartPageAsideWrapper__nGT4r","br":"styles_br__c2XyZ"};